import { Crown } from "lucide-react";

export const ChampionBadge = ({ testid, compact }) => (
  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-gradient-to-r from-[#F4B860] to-[#D96B43] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white shadow-sm" title="Last week's champion" data-testid={testid}>
    <Crown className="h-3 w-3" />{compact ? <span className="hidden sm:inline">Champion</span> : "Last week's champion"}
  </span>
);
